import {
  genericXHRErrorHandler,
  getAuthHeader,
  isMobile,
  toastInfoSingle
} from "src/components/Planner/controller";
import $ from "jquery";
import {ROOT_URI} from "src/utils/constants";
import {getFrontendURL} from "src/utils/url";
import {
  getDeviceById,
  getRoomById,
  getSerialById,
  getSerialCenterPos2,
  getSerialOfDeviceId,
  ghostDevProps,
  rebuildWallsCache,
  uDev,
  wallsOfRoom
} from "src/components/Planner/planner/uDev";
import { canBeDevMerged, uDevDOM } from "src/components/Planner/planner/uDev-dom";
import {
  _does,
  distToWall,
  getClosestWallToPoint,
  getWallById,
  lineClosestPointToPoint,
  P_numtoxy,
  P_xytonum,
  uMath,
  vectorRotationDegree,
  wallClosestPointToPoint
} from "src/components/Planner/planner/uMath";
import { drawSnapLines } from "src/components/Planner/planner/deviceGeometry";
import {wallModHelper} from "src/components/Planner/planner/wallModHelper";
import {
  CreateMeasurementAction,
  DeleteMeasurementAction
} from "src/components/Planner/planner/history/measurement-actions";
import {
  drawLengthLine,
  firstOfType,
  getCenterOfD,
  getDevicePositionCenter,
  getRoomByPoint,
  getXYP,
  hideRotateAndDeviceTools,
  hideTools,
  isThingShown,
  MEASURE_TYPES,
  originalFromD,
  removeLengthLines,
  setMode,
  toolbarSwitchSet,
  twoClosestWallsWithPoints
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import * as d3 from "d3";
import {ts} from "src/utils/translate";
import {
  createToolTooltip,
  drawToolBackground,
  getToolSize
} from "src/components/Planner/planner/deviceTools";
import {
  getSerialCenterPos
} from "src/components/Planner/planner/serialConnections";
import {
  hasPermissionForFuncInRole
} from "src/utils/controllerHasPermissionsAdapter";

export function measureTypeById(id) {
  return PlannerGlobals.measurement_types.find(function (x) {
    return x.id == id;
  });
}

export function measureTypeById_T(id) {
  return measureTypeById(id).measurement_type;
}

export function measureTypeByKey(type) {
  return PlannerGlobals.measurement_types.find(function (x) {
    return x.measurement_type == type;
  });
}

/**
 *
 * @param {number | string} deviceId
 */
export function getMeasurementsOfDevice(deviceId) {
  deviceId = deviceId.toString();
  var type = deviceId.indexOf('C_') === 0 ? measureTypeById_T(
      MEASURE_TYPES.userCustomItem) : measureTypeById_T(MEASURE_TYPES.device);
  if (type === measureTypeById_T(MEASURE_TYPES.userCustomItem)) {
    deviceId = deviceId.replace('C_', '');
  }
  deviceId = +deviceId;
  return PlannerGlobals.measurements.filter(function (meas) {
    var src = meas.source;
    var tar = meas.target;
    return src.type === type && src.id === deviceId ||
        tar.type === type && tar.id === deviceId;
  });
}

/**
 *
 * @param {number} serialId
 */
export function getMeasurementsOfSerial(serialId) {
  serialId = +serialId;
  return PlannerGlobals.measurements.filter(function (meas) {
    var src = meas.source;
    var tar = meas.target;
    return src.type === "serial" && src.id === serialId || tar.type === "serial"
        && tar.id === serialId;
  });
}

/**
 *
 * @param {number} wallModId
 */
export function getMeasurementsOfWallMod(wallModId) {
  wallModId = +wallModId;
  var type = measureTypeById_T(MEASURE_TYPES.wallMod);
  return PlannerGlobals.measurements.filter(function (meas) {
    var src = meas.source;
    var tar = meas.target;
    return src.type === type && +src.id === wallModId || tar.type === type
        && +tar.id === wallModId;
  });
}

/**
 *
 * @param {number} wallModConnId
 */
export function getMeasurementsOfWallModConn(wallModConnId) {
  return wallModHelper.getWallModsByConnId(wallModConnId)
  .map(function (wallMod) {
    return getMeasurementsOfWallMod(wallMod.id);
  }).reduce(function (p, c) {
    return p.concat(c);
  }, []);
}

export function removeSerialFromMeasurements(serialId) {
  PlannerGlobals.measurements = PlannerGlobals.measurements.filter(
      function (meas) {
        var src = meas.source;
        var tar = meas.target;
        var res = !(src.type == "serial" && src.id == serialId || tar.type
            == "serial" && tar.id == serialId);
        if (!res) {
          removeMeasurementLine(meas.id);
        }
        return res;
      });
}

export function removeDeviceFromMeasuresLocal(deviceId) {
  var removeds = [];
  PlannerGlobals.measurements = PlannerGlobals.measurements.filter(
      function (meas) {
        var src = meas.source;
        var tar = meas.target;
        if (src.type == "device" && src.id == deviceId || tar.type == "device"
            && tar.id == deviceId) {
          removeMeasurementLine(meas.id);
          removeds.push(meas);
          return false;
        } else if (src.type == measureTypeById(4).measurement_type && src.id
            == deviceId.toString().replace('C_', '') ||
            tar.type == measureTypeById(4).measurement_type && tar.id
            == deviceId.toString().replace('C_', '')) {
          removeMeasurementLine(meas.id);
          removeds.push(meas);
          return false;
        }
        return true;
        /* return !(src.type == "device" && src.id == deviceId || tar.type == "device" && tar.id == deviceId ||
                src.type == measureTypeById(4).measurement_type && ('C_' + src.id) == deviceId || tar.type == measureTypeById(4).measurement_type && ('C_' + src.id) == deviceId); */
      });
  return removeds;
}

export function removeWallModFromMeasuresLocal(wallModId) {
  PlannerGlobals.measurements = PlannerGlobals.measurements.filter(
      function (meas) {
        if (measureHelper.doesMeasurementHaveType(meas, measureTypeById_T(5))) {
          var wallModMeas = measureHelper.getMeasurementFromConnection(meas,
              measureTypeById_T(5));
          if (wallModMeas[0].id == wallModId) {
            removeMeasurementAjax(meas.id);
            return false;
          }
          return true;
        } else {
          return true;
        }
      });
}

export function draw_measureMeMove() {
  if (PlannerGlobals.mode != 'measureMe') {
    return;
  }
  removeLengthLines();

  var target = measureHelper.getTargetWallOrDev();
  if (target) {
    drawLengthLine(measureHelper.sourceCenter, measureHelper.targetCenter,
        undefined, undefined, "justDrawing");
  } else {
    var underCursor = getXYP();
    drawLengthLine(measureHelper.sourceCenter, underCursor, undefined,
        undefined, "justDrawing");
  }
}

export function convertMeasurements(measurements) {
  var filtered_test = [];
  var mapped = measurements.map(function (meas) {
    var measurement = {source: {}, target: {}};
    measurement.source.id = meas.source_id;
    measurement.source.type = measureTypeById(
        meas.source_type_id).measurement_type;
    measurement.target.id = meas.target_id;
    measurement.target.type = measureTypeById(
        meas.target_type_id).measurement_type;
    measurement.id = meas.id;
    return measurement;
  });
  var filtered = mapped.filter(function (meas) {
    if (measureHelper.doesExist(meas.target) && measureHelper.doesExist(
        meas.source)) {
      return true;
    } else {
      filtered_test.push(meas);
      return false;
    }
  });
  if (mapped.length != filtered.length) {
    console.debug("There were some filtered measurements!", filtered_test);
  }
  return filtered;
}

export function recalcWallMeasurement(meas) {
  var conn = measureHelper.getMeasurementFromConnection(meas, "wall");
  if (!conn) {
    return;
  }
  var wall = conn[0];
  var other = conn[1];

  other.center = measureHelper.getMeasurePtOf(other);
  var closestPt = wallClosestPointToPoint(other.center, getWallById(wall.id));
  wall.center = closestPt;
}

export function recalcWallModMeasurement(meas) {
  var conn = measureHelper.getMeasurementFromConnection(meas,
      measureTypeById_T(5))
  if (!conn) {
    return;
  }
  var wallMod = conn[0];
  var other = conn[1];

  other.measurePtOverride = null;
  other.center = measureHelper.getMeasurePtOf(other);

  var closestPts = [];

  var wallModObj = wallModHelper.getWallModById(wallMod.id);
  for (var pt of wallModObj.points) {
    var translatedPt;
    if ('translatedPt' in pt) {
      translatedPt = pt.translated;
    } else {
      translatedPt = uMath.translatePoint(pt, 0, 10,
          vectorRotationDegree(wallModObj.points[0], wallModObj.points[1]));
      pt.translated = translatedPt;
    }
    closestPts.push(lineClosestPointToPoint(other.center, pt, translatedPt));
  }

  var closerPt;

  if (uMath.pointDistance(other.center, closestPts[0]) < uMath.pointDistance(
      other.center, closestPts[1])) {
    closerPt = 0;
  } else {
    closerPt = 1;
  }
  wallMod.center = closestPts[closerPt];
  if (other.type == "serial") {
    other.measurePtOverride = uDev.getSerialRectLineIntersect(other.id,
        uMath.segmentFromPoints(wallMod.center, other.center));
  }
  return [wallModObj.points[closerPt], wallMod.center];
}

export function recalcSerialMeasurement(meas) {
  var conn = measureHelper.getMeasurementFromConnection(meas, "serial");
  if (!conn) {
    return;
  }
  var serial = conn[0];
  var other = conn[1];

  serial.measurePtOverride = null;
  if (other.type == "serial") {
    other.measurePtOverride = null;
    var pairs = [];
    var ser1 = getSerialById(serial.id);
    var ser2 = getSerialById(other.id);
    for (var i = 0; i < ser1.deviceIds.length; i++) {
      var di1 = ser1.deviceIds[i];
      var pos1 = uDev.getCenterOfDevice_NoDOM(di1);
      for (var j = 0; j < ser2.deviceIds.length; j++) {
        var di2 = ser2.deviceIds[j];
        var pos2 = uDev.getCenterOfDevice_NoDOM(di2);
        var dist = uMath.pointDistance(pos1, pos2);
        pairs.push({pos1, pos2, dist});
      }
    }
    pairs.sort(function (a, b) {
      return a.dist < b.dist ? -1 : 1;
    });
    serial.measurePtOverride = pairs[0].pos1;
    other.measurePtOverride = pairs[0].pos2;
  } else {
    var otherCenter = measureHelper.getMeasurePtOf(other);
    var serialDevs = getSerialById(serial.id).deviceIds.map(function (devid) {
      var pos = uDev.getCenterOfDevice_NoDOM(devid);
      var len = uMath.pointDistance(pos, otherCenter);
      return {pos, len};
    });
    serialDevs.sort(function (a, b) {
      return a.len < b.len ? -1 : 1;
    });
    serial.measurePtOverride = serialDevs[0].pos;
  }
}

export function drawMeasureExtraLine(p1, p2, container, cls, source) {
  container.append("line")
  .attr("class", cls)
  .attr("id", function (d) {
    if (source) {
      return "extra_measure_" + source.id
    } else {
      return ""
    }
  })
  .attr("data-measurementId", function (d) {
    if (source) {
      return source.id
    } else {
      return ""
    }
  })
  .attr("x1", p1.x)
  .attr("y1", p1.y)
  .attr("x2", p2.x)
  .attr("y2", p2.y)
  .attr("stroke", "black")
  .attr("stroke-width", "0.2px")
  .attr("style", "pointer-events: none;");
}

export function sweepMeasurements() {
  var valids = {};
  PlannerGlobals.measurements.forEach(function (meas) {
    valids[meas.id] = true;
  });
  $('.measurements').children().each(function () {
    var $this = $(this);
    if (!($this.attr('data-measurementId') in valids)) {
      $this.remove();
    }
  });
}

/**
 *
 * @param {MeasurementConnection[]} measurementConns
 */
export function correct180DegMeasures(measurementConns) {
  var connsDict = {};
  measurementConns.forEach(function (conn) {
    if (measureHelper.doesMeasurementHaveType(conn,
        measureTypeById_T(MEASURE_TYPES.wall))) {
      conn.siblingConnLen = null;
      var wallAndOther = measureHelper.getMeasurementFromConnection(conn,
          measureTypeById_T(MEASURE_TYPES.wall));
      var wallPos = measureHelper.getMeasurePtOf(wallAndOther[0]);
      var otherPos = measureHelper.getMeasurePtOf(wallAndOther[1]);
      var uId = wallAndOther[1].type + '_' + wallAndOther[1].id;
      if (uId in connsDict) {
        connsDict[uId].push({conn, wallPos, otherPos});
      } else {
        connsDict[uId] = [{conn, wallPos, otherPos}];
      }
    }
  });

  for (let uId in connsDict) {
    var connsOfElem = connsDict[uId];
    for (var i = 0; i < connsOfElem.length - 1; i++) {
      for (var j = i + 1; j < connsOfElem.length; j++) {
        var p1 = connsOfElem[i];
        var p2 = connsOfElem[j];

        if (p1.conn.siblingConnLen || p2.conn.siblingConnLen) {
          continue;
        }

        var seg1 = uMath.segmentFromPoints(p1.wallPos, p1.otherPos);
        var seg2 = uMath.segmentFromPoints(p2.wallPos, p2.otherPos);

        if (uMath.areSegmentsParallel(seg1, seg2)) {
          var lenSimilar = uMath.areSegmentsSimilarLong(seg1, seg2, 5);
          if (lenSimilar.result) {
            p1.conn.siblingConnLen = lenSimilar.length;
            p2.conn.siblingConnLen = lenSimilar.length;
          } else {
            p1.conn.siblingConnLen = null;
            p2.conn.siblingConnLen = null;
          }
        } else {
          p1.conn.siblingConnLen = null;
          p2.conn.siblingConnLen = null;
        }
      }
    }
  }
}

export function redrawMeasurements() {
  d3.select("#measurements").remove();
  if (PlannerGlobals.measurements_on) {

    /* var meas = container.insert("g", ".devices") */
    var meas = PlannerGlobals.container.append("g")
    .attr("class", "measurements")
    .attr("id", "measurements");
    for (var i = 0; i < PlannerGlobals.measurements.length; i++) {
      var curr = PlannerGlobals.measurements[i];
      if (isThingShown(curr.source) && isThingShown(curr.target)) {
        if (measureHelper.doesMeasurementHaveType(curr, "wall")) {
          recalcWallMeasurement(curr);
        }
        if (measureHelper.doesMeasurementHaveType(curr, measureTypeById_T(5))) {
          curr.connectPoints = recalcWallModMeasurement(curr);
        }
        if (measureHelper.doesMeasurementHaveType(curr, "serial")) {
          recalcSerialMeasurement(curr);
        }
      }
    }
    filterInvalidMeasurements(true);
    correct180DegMeasures(PlannerGlobals.measurements);
    for (var i = 0; i < PlannerGlobals.measurements.length; i++) {
      var curr = PlannerGlobals.measurements[i];
      if (curr.invalid || !(isThingShown(curr.source) && isThingShown(
          curr.target))) {
        continue;
      }
      if (curr.connectPoints) {
        drawMeasureExtraLine(curr.connectPoints[0], curr.connectPoints[1], meas,
            "measExtraLine", curr);
      }
      drawLengthLine(measureHelper.getMeasurePtOf(curr.source),
          measureHelper.getMeasurePtOf(curr.target), meas, "constantLengthLine",
          curr);
    }

    toolbarSwitchSet("measure-display", "on");
  } else {
    toolbarSwitchSet("measure-display", "off");
  }
}

export function removeMeasurementLine(measurementId) {
  $("#text_measure_" + measurementId).remove();
  $("#line_measure_" + measurementId).remove();
  $("#rect_measure_" + measurementId).remove();
  $("#extra_measure_" + measurementId).remove();
}

export function redrawMeasurementsOf(d) {
  if (PlannerGlobals.measurements_on) {
    var meas = d3.select("#measurements");
    var measurements_f = getMeasurementConnectionsOfD(d);
    for (var curr of measurements_f) {
      $("#text_measure_" + curr.id).remove();
      $("#line_measure_" + curr.id).remove();
      $("#rect_measure_" + curr.id).remove();
      $("#extra_measure_" + curr.id).remove();
      if (isThingShown(curr.source) && isThingShown(curr.target)) {
        if (measureHelper.doesMeasurementHaveType(curr, "wall")) {
          recalcWallMeasurement(curr);
        }
        if (measureHelper.doesMeasurementHaveType(curr, measureTypeById_T(5))) {
          curr.connectPoints = recalcWallModMeasurement(curr);
        }
        if (measureHelper.doesMeasurementHaveType(curr, "serial")) {
          recalcSerialMeasurement(curr);
        }
      }
    }
    filterInvalidMeasurements(true);
    correct180DegMeasures(measurements_f);
    for (var i = 0; i < measurements_f.length; i++) {
      var curr = measurements_f[i];
      if (curr.invalid) {
        continue;
      }
      if (curr.connectPoints) {
        drawMeasureExtraLine(curr.connectPoints[0], curr.connectPoints[1], meas,
            "measExtraLine", curr);
      }
      drawLengthLine(measureHelper.getMeasurePtOf(curr.source),
          measureHelper.getMeasurePtOf(curr.target), meas, "constantLengthLine",
          curr);
    }

    toolbarSwitchSet("measure-display", "on");
  } else {
    toolbarSwitchSet("measure-display", "off");
  }
}

export function isDInMeasures(d) {
  if (d.connId) {
    const ids = d.serials.map(ser => +ser.serialId);
    return PlannerGlobals.measurements.some(
        meas => meas.source.type == "serial" && _does(ids).contain(
            +meas.source.id) || meas.target.type == "serial" && _does(
            ids).contain(+meas.target.id));
  }
  var id = d.id ? d.id : d.devices[0].deviceId;
  var type;
  if (d.id) {
    type = "serial";
  } else {
    if (id.toString().indexOf('C_') == 0) {
      type = measureTypeById(4).measurement_type;
      id = id.toString().replace('C_', '');
    } else {
      type = "device";
    }
  }
  for (var i = 0; i < PlannerGlobals.measurements.length; i++) {
    var meas = PlannerGlobals.measurements[i], src = meas.source,
        tar = meas.target;
    if (src.type == type && src.id == id || tar.type == type && tar.id == id) {
      return true;
    }
  }
  return false;
}

export function dragDrawTempMeasurements(snappedPos, d) {
  if (snappedPos && snappedPos.measureLinePtPairs) {
    removeLengthLines();
    drawSnapLines(snappedPos.measureLinePtPairs);
  } else if (d.roomId != uDev.OUTDOORS_ROOM_ID && d.roomId
      != uDev.UNASSIGNED_ROOM_ID) {
    var firstPNID = d.devices[0].product_name_id;

    // TODO LEHET HOGY A firstOfType nem kell ha merged
    //if (!d.id && canBeDevMerged(d.devices[0]) && d.roomId != d.dragStartRoomId && firstOfType(firstPNID, d.roomId).deviceId < d.devices[0].deviceId) {
    if (!d.id && d.roomId != d.dragStartRoomId && firstOfType(firstPNID,
        d.roomId).deviceId < d.devices[0].deviceId) {
      removeLengthLines();
    } else {
      if (d.connId && d.serials.reduce(
          (p, ser) => (p + getMeasurementsOfD(ser.serObj).length), 0) >= 2) {
        return;
      }

      var fromPt;
      var room;
      const connTarget = d.connId ? d.serials[0].serObj : d;
      var xy = getCenterOfD(connTarget);

      if (snappedPos && !d.connId) {
        var gdp = ghostDevProps();
        fromPt = {x: gdp.cx, y: gdp.cy};
        room = snappedPos.room;
      } else {
        fromPt = xy;
        room = getRoomByPoint(xy);
      }

      removeLengthLines();
      if (room) {
        var walls = twoClosestWallsWithPoints(fromPt, room, connTarget);
        for (var i = 0; i < 2; i++) {
          if (walls[i] && walls[i].closestPt) {
            drawLengthLine(fromPt, walls[i].closestPt);
          }
        }
      }
    }
  }
}

export function getMeasurementEntity(thing) {
  if (thing.type == "wall") {
    return getWallById(thing.id);
  } else if (thing.type == "device") {
    return getDeviceById(thing.id);
  } else if (thing.type == measureTypeById_T(4)) {
    return getDeviceById('C_' + thing.id);
  } else if (thing.type == "serial") {
    var ser = getSerialById(thing.id);
    if (ser) {
      ser.roomId = getDeviceById(ser.deviceIds[0]).roomId;
    }
    return ser;
  } else if (thing.type == measureTypeById_T(5)) {
    return wallModHelper.getWallModById(thing.id);
  } else {
    return thing;
  }
}

/**
 *
 * @param {MeasurementTarget} obj
 * @returns {Wall}
 */
export function closestWallToMeasureObj(obj) {
  var center = measureHelper.getMeasurePtOf(obj, true);
  var origi = measureHelper.datum(obj);
  if (!origi) {
    return false;
  }
  var room = getRoomById(origi.roomId);
  if (!room) {
    return false;
  }
  var walls = wallsOfRoom(room);
  for (var wall of walls) {
    wall.distToCenter = distToWall(center, wall);
  }
  return walls.sort(function (a, b) {
    return a.distToCenter < b.distToCenter ? -1 : 1;
  })[0];
}

export function invalidateMeasurement(meas, noAjax, reason) {
  meas.invalid = true;
  if (!noAjax) {
    if (reason) {
      toastInfoSingle(reason);
    }
    if (!meas.sentToServerPromise) {
      removeMeasurementAjax(meas.id);
    } else {
      meas.sentToServerPromise.then(function () {
        removeMeasurementAjax(meas.id);
      });
    }
    /* return false; */
  }
  return false;
}

export function isMeasurementValid(meas, noAjax, recalc = false) {
  recalcWallMeasurement(meas);
  if (recalc) {
    meas.connectPoints = recalcWallModMeasurement(meas);
    recalcSerialMeasurement(meas);
    recalcWallMeasurement(meas);
  }

  var sc = meas.source.measurePtOverride || meas.source.center,
      tc = meas.target.measurePtOverride || meas.target.center;

  if (measureHelper.doesMeasurementHaveType(meas, "wall")) {
    var conn = measureHelper.getMeasurementFromConnection(meas, "wall");
    var wall = conn[0], other = conn[1];

    // delete measurement beacause its wall changed
    if (wall.id in PlannerGlobals.changedWalls) {
      return invalidateMeasurement(meas, noAjax, ts('p_meas_info_wallchanged',
          "Measurement got removed because its wall has changed."));
    }
    var perpend = uMath.areSegmentsPerpendicular(getWallById(wall.id),
        uMath.segmentFromPoints(wall.center,
            measureHelper.getMeasurePtOf(other)));
    // delete
    if (!perpend) {
      return invalidateMeasurement(meas, noAjax, ts('p_meas_info_notinsight',
          "Measurement got removed because it's not perpendicular to the wall."));
    }
  } else if (measureHelper.doesMeasurementHaveType(meas,
      measureTypeById_T(MEASURE_TYPES.wallMod))) {
    var conn = measureHelper.getMeasurementFromConnection(meas,
        measureTypeById_T(MEASURE_TYPES.wallMod));
    var wallMod = conn[0], other = conn[1];

    // if distance from wall is big it's bad
    if (meas.connectPoints && uMath.pointDistance(meas.connectPoints[0],
        meas.connectPoints[1]) > PlannerGlobals.DEVICE_SIZE * 3) {
      return invalidateMeasurement(meas, noAjax, ts('p_meas_info_toofar',
          "Measurement got removed because the device is too far away from the window or door."));
    }
    var wallModObj = wallModHelper.getWallModById(wallMod.id);

    for (var wallId of wallModObj.wallIds) {
      if (wallId in PlannerGlobals.changedWalls) {
        return invalidateMeasurement(meas, noAjax, ts('p_meas_info_wallchanged',
            "Measurement got removed because its wall has changed."));
      }
    }

    var closestWallToObj = closestWallToMeasureObj(other);
    if (closestWallToObj && !wallModHelper.wallModObjCompatibleWithWall(
        wallModObj, closestWallToObj)) {
      return invalidateMeasurement(meas, noAjax,
          ts('p_meas_info_differentwalls',
              "The measured entities have to be on the same wall."));
    }

  }

  if (measureHelper.doesMeasurementHaveType(meas,
      measureTypeById_T(MEASURE_TYPES.device))) {
    var conn = measureHelper.getMeasurementFromConnection(meas,
        measureTypeById_T(MEASURE_TYPES.device));
    var dev = conn[0];
    var other = conn[1];
    var dev1 = getDeviceById(dev.id);
    if (!dev1) {
      return invalidateMeasurement(meas, noAjax);
    }
    if (canBeDevMerged(dev1)) {
      var firstOfDev1 = firstOfType(dev1.product_name_id, dev1.roomId);
      if (firstOfDev1 && firstOfDev1.deviceId != dev1.deviceId) {
        return invalidateMeasurement(meas, noAjax);
      }
    }
    if (other.type == measureTypeById_T(MEASURE_TYPES.device)) {
      var dev2 = getDeviceById(other.id);
      if (!dev2) {
        return invalidateMeasurement(meas, noAjax);
      }
      if (canBeDevMerged(dev2)) {
        var firstOfdev2 = firstOfType(dev2.product_name_id, dev2.roomId);
        if (firstOfdev2 && firstOfdev2.deviceId != dev2.deviceId) {
          return invalidateMeasurement(meas, noAjax);
        }
      }
    }
  }

  if (sc && tc && uMath.pointDistance(sc, tc) < PlannerGlobals.DEVICE_SIZE
      * 0.8) {
    return invalidateMeasurement(meas, noAjax, ts('p_meas_info_tooshort',
        "Measurement got removed because it's too short."));
  }
  meas.invalid = false;
  return true;
}

/**
 *
 * @param {boolean} noAjax
 * @returns {MeasurementConnection[]}
 */
export function filterInvalidMeasurements(noAjax) {
  var invalids = [];
  PlannerGlobals.measurements = PlannerGlobals.measurements.filter(
      function (meas) {
        var res = isMeasurementValid(meas, noAjax);
        if (!res) {
          invalids.push(meas);
        }
        if (noAjax) {
          return true;
        }
        return res;
      });
  return invalids;
}

/**
 *
 * @param {MeasurementTarget} src
 * @param {string} tarTypeFilter
 * @returns {MeasurementTarget[]}
 */
export function getMeasurementOthers(src, tarTypeFilter) {

  return PlannerGlobals.measurements.map(function (meas) {
    if (meas.source.type == src.type && meas.source.id == src.id
        && !meas.invalid) {
      if (!tarTypeFilter || tarTypeFilter && meas.target.type
          == tarTypeFilter) {
        return meas.target;
      }
    } else if (meas.target.type == src.type && meas.target.id == src.id
        && !meas.invalid) {
      if (!tarTypeFilter || tarTypeFilter && meas.target.type
          == tarTypeFilter) {
        return meas.source;
      }
    }
  }).filter(function (x) {
    return x;
  })

}

export function getMeasurementConnectionsOfD(d) {
  if (!d) {
    return [];
  }
  return PlannerGlobals.measurements.filter(function (meas) {
    var type, id;
    if (d.id) {
      type = "serial";
      id = d.id;
    } else if (d.connId) {
      type = "serial";
      const ids = d.serials.map(ser => +ser.serialId);
      return meas.source.type == type && _does(ids).contain(+meas.source.id)
          || meas.target.type == type && _does(ids).contain(+meas.target.id);
    } else {
      var devId = d.devices[0].deviceId.toString();
      if (devId.indexOf('C_') == 0) {
        type = measureTypeById_T(4);
        id = devId.replace('C_', '');
      } else {
        type = "device";
        id = devId;
      }
    }
    return meas.source.type == type && meas.source.id == id || meas.target.type
        == type && meas.target.id == id;
  });
}

export function getMeasurementsOfD(d, tarTypeFilter) {
  if (!d) {
    return [];
  }
  if (d.id) {
    // serial
    return getMeasurementOthers({id: d.id, type: "serial"}, tarTypeFilter);
  } else {
    // dev
    var id = d.devices[0].deviceId;
    if (id.toString().indexOf('C_') == 0) {
      return getMeasurementOthers({
        id: id.toString().replace('C_', ''),
        type: measureTypeById(4).measurement_type
      }, tarTypeFilter);
    } else {
      return getMeasurementOthers({id: id, type: "device"}, tarTypeFilter);
    }
  }
}

export function removeMeasurementByClick(id, callback, errorCallback) {
  if (PlannerGlobals.hideRedXTimeout) {
    clearTimeout(PlannerGlobals.hideRedXTimeout);
  }
  hideTools();
  var measurement = PlannerGlobals.measurements.find(function (meas) {
    return meas.id == id;
  });
  if (measurement && !measureHelper.connIsGhost(measurement)) {
    measurement.justDeleted = true;
    redrawMeasurements();

    removeMeasurementAjax(id, function () {
      var action = new DeleteMeasurementAction(measurement);
      PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);

      PlannerGlobals.measurements = PlannerGlobals.measurements.filter(
          function (meas) {
            return meas.id != id;
          });
      redrawMeasurements();
    }, function () {
      measurement.justDeleted = false;
      redrawMeasurements();
    });
  }
}

export function showMeasureDelTool(elem) {
  var elem = $(elem);

  if (PlannerGlobals.mode !== "basic" || elem.attr('data-measurementId') === ""
      ||
      !hasPermissionForFuncInRole("planner_sect.show_prod_buttons", PlannerGlobals.userRoleInProject)) {
    return;
  }
  if (PlannerGlobals.hideRedXTimeout) {
    clearTimeout(PlannerGlobals.hideRedXTimeout);
  }

  $(elem).off('mousedown.md');
  $(elem).bindFirst('mousedown.md', function (e) {
    try {
      var x = e.clientX;
      var y = e.clientY;

      var elems = document.elementsFromPoint(x, y);

      for (var i = 0; i < elems.length; i++) {
        var elemUnderPt = elems[i];
        if (elemUnderPt.classList.contains('device')) {
          e.stopPropagation();
          var clickElem = $(elemUnderPt).closest('g')[0];
          clickElem.dispatchEvent(new MouseEvent('mousedown'));
          $(document).one('mouseup', function () {
            setTimeout(function () {
              elemUnderPt.dispatchEvent(new MouseEvent('click'));
            }, 5);
          });
          break;
        }
      }
    } catch (e) {
      console.log(e);
    }
  });

  hideRotateAndDeviceTools();

  const elemBox = {
    x: +elem.attr('x'),
    y: +elem.attr('y'),
    width: +elem.attr('width'),
    height: +elem.attr('height'),
  }
  const elemTopCenter = {x: elemBox.x + elemBox.width / 2, y: elemBox.y};

  const sizes = getToolSize();
  const toolSize = sizes.size;
  const toolPadding = sizes.padding;
  const toolX = elemTopCenter.x - toolSize / 2 - toolPadding / 2;
  const toolY = elemTopCenter.y - toolSize - toolPadding - 1;

  const rectBox = {
    x: toolX - toolPadding,
    y: toolY - toolPadding,
    width: toolSize + toolPadding * 2,
    height: toolSize + toolPadding * 2
  };
  const rectExtra = {
    class: 'device-tool'
  };
  drawToolBackground(PlannerGlobals.container, rectBox, rectExtra);

  PlannerGlobals.container
    .append("svg:image")
    .attr('width', toolSize)
    .attr('height', toolSize)
    .attr("x", toolX)
    .attr("y", toolY)
    .attr("xlink:href", getFrontendURL() + '/images/planner_tools/delete.svg')
    .attr("class", "device-tool uplan-touchable")
    .attr("title", ts("p_tool_delete", "Delete"))
    .attr("id", "redx")
    .on("click", function () { removeMeasurementByClick(+elem.attr('data-measurementId')); });

  createToolTooltip('.device-tool');

  if (!isMobile) {
    $('.device-tool').off('mousedown.tool');
    $('.device-tool').on('mousedown.tool', function (e) {
      e.stopImmediatePropagation();
    });

    $('.device-tool, #' + elem.attr('id')).off('mouseout.tool');
    $('.device-tool, #' + elem.attr('id')).on('mouseout.tool', function () {
      if (PlannerGlobals.hideRedXTimeout) {
        clearTimeout(PlannerGlobals.hideRedXTimeout);
      }
      PlannerGlobals.hideRedXTimeout = setTimeout(function () {
        hideTools();
      }, 2500);
    });

    $('.device-tool, #' + elem.attr('id')).off('mouseenter.tool');
    $('.device-tool, #' + elem.attr('id')).on('mouseenter.tool', function () {
      if (PlannerGlobals.hideRedXTimeout) {
        clearTimeout(PlannerGlobals.hideRedXTimeout);
      }
    });
  }
}

export function toggleMeasurements() {
  if (PlannerGlobals.mode == "measureMe" || PlannerGlobals.mode
      == "measurePrepare") {
    setMode.basic();
  }

  PlannerGlobals.measurements_on = !PlannerGlobals.measurements_on;
  redrawMeasurements();
}

export function measurePrepareCleanup() {
  if (PlannerGlobals.mode == "measurePrepare") {
    removeLengthLines();
    $("#measure-distance-btn").removeClass("pressed");
    PlannerGlobals.svg.style('cursor', '');
  }
}

export function resetMeasureProps() {
  measureHelper.sourceId = undefined;
  measureHelper.sourceCenter = undefined;
  measureHelper.sourceType = undefined;
  measureHelper.sourceRoom = undefined;
  measureHelper.targetId = undefined;
  measureHelper.targetType = undefined;
  measureHelper.targetCenter = undefined;
}

export function addMeasurementAjax(measurement, callback, errorCallback) {
  getAuthHeader(function (headers) {
    $.ajax({
      method: "post",
      headers: headers,
      url: ROOT_URI + '/floor/measurement',
      data: {
        floor_id: PlannerGlobals.plannerFloorId,
        source_id: measurement.source.id,
        target_id: measurement.target.id,
        source_type_id: measureTypeByKey(measurement.source.type).id,
        target_type_id: measureTypeByKey(measurement.target.type).id,
      },
      success: function (resp) {
        measurement.id = resp.id;
        measurement.justAdded = false;
        measurement.sentToServerPromise.resolve();
        redrawMeasurements();
        filterInvalidMeasurements();
        if (typeof callback === "function") {
          callback(measurement);
        }
      },
      error: function (resp) {
        PlannerGlobals.measurements = PlannerGlobals.measurements.filter(
            function (x) {
              return x != measurement;
            });
        measurement.sentToServerPromise.reject();
        redrawMeasurements();
        filterInvalidMeasurements();
        genericXHRErrorHandler(resp);
        if (typeof errorCallback === "function") {
          errorCallback();
        }
      }
    });
  });
}

export function removeMeasurementAjax(id, callback, errorCallback) {
  getAuthHeader(function (headers) {
    $.ajax({
      headers: headers,
      url: ROOT_URI + '/floor/measurement',
      method: 'delete',
      data: {
        measurement_id: id
      },
      success: function () {
        if (typeof callback === "function") {
          callback();
        }
      },
      error: function (resp) {
        genericXHRErrorHandler(resp);
        if (typeof errorCallback === "function") {
          errorCallback();
        }
      }
    });
  });
}

export const measureHelper = {
  sourceId: undefined,
  sourceCenter: undefined,
  sourceType: undefined,
  sourceRoom: undefined,
  targetId: undefined,
  targetType: undefined,
  targetCenter: undefined,
  deviceCentersCache: [],
  serialCentersCache: [],
  /**
   *
   * @param {string} type1
   * @param {string} type2
   * @returns {MeasurementTarget[]}
   */
  getMeasurementsByConnectionType: function (type1, type2) {
    return PlannerGlobals.measurements.filter(function (meas) {
      return meas.source.type == type1 && meas.target.type == type2
          || meas.source.type == type2 && meas.target.type == type1;
    });
  },
  /**
   *
   * @param {MeasurementConnection} measurement
   * @param {string} type
   * @returns {MeasurementTarget[]}
   */
  getMeasurementFromConnection: function (measurement, type) {
    if (measurement.source.type == type) {
      return [measurement.source, measurement.target];
    } else if (measurement.target.type == type) {
      return [measurement.target, measurement.source];
    }
    return null;
  },
  /**
   * @param {MeasurementConnection} measurement
   * @param {string} type
   * @returns {boolean}
   */
  doesMeasurementHaveType: function (measurement, type) {
    return measurement.source.type == type || measurement.target.type == type;
  },
  /**
   *
   * @param {MeasurementConnection} measurement
   * @param {string} type1
   * @param {string} type2
   * @returns {boolean}
   */
  isMeasurementTypeOf: function (measurement, type1, type2) {
    return measurement.source.type == type1 && measurement.target.type == type2
        ||
        measurement.source.type == type2 && measurement.target.type == type1;
  },
  rebuildCaches: function () {
    var thisVar = this;
    thisVar.deviceCentersCache = [];
    PlannerGlobals.devices.forEach(function (device) {
      if (device.ghost || device.deviceId.toString().indexOf("S_") == 0) {
        return;
      }
      /* if (device.roomId != thisVar.sourceRoom) { return; } */
      var ser = getSerialOfDeviceId(device.deviceId);
      if (ser) {
        return;
      }
      var center = getDevicePositionCenter(device);
      var dev = {device: device, center: P_numtoxy(center)};
      thisVar.deviceCentersCache.push(dev);
    });
    thisVar.serialCentersCache = [];
    PlannerGlobals.serials.forEach(function (serial) {
      /* var roomId = getDeviceById(serial.deviceIds[0]).roomId; */
      /* if (roomId != thisVar.sourceRoom) { return; } */
      if (serial.deviceIds.map(getDeviceById).every(function (dev) {
        return dev.ghost;
      })) {
        return;
      }
      /* var center = getSerialCenterPos(getSerialD(serial.id)); */
      /* var ser = { serial: serial, center: P_numtoxy(center) }; */
      var center = getSerialCenterPos2(serial);
      var ser = {serial, center};
      thisVar.serialCentersCache.push(ser);
    });
  },
  /**
   *
   * @param {MeasurementTarget} elem
   */
  datum: function (elem) {
    switch (elem.type) {
      case "serial":
        return getSerialById(elem.id);
      case "device":
        return getDeviceById(elem.id);
      case measureTypeById_T(MEASURE_TYPES.userCustomItem):
        return getDeviceById('C_' + elem.id);
      case "wall":
        return getWallById(elem.id);
      case measureTypeById_T(MEASURE_TYPES.wallMod):
        return wallModHelper.getWallModById(elem.id);
      default:
        return true;
    }
  },
  /**
   *
   * @param {MeasurementConnection} conn
   */
  connIsGhost: function (conn) {
    if (!conn) {
      return false;
    }
    return measureHelper.tarIsGhost(conn.source) || measureHelper.tarIsGhost(
        conn.target);
  },
  /**
   *
   * @param {MeasurementTarget} tar
   */
  tarIsGhost(tar) {
    if (!tar) {
      return false;
    }
    var elem = measureHelper.datum(tar);
    return ("ghost" in elem && elem.ghost) || ("isAJAXWait" in elem
        && elem.isAJAXWait);
  },
  doesExist: function (elem) {
    /* if (elem.type == "serial") {
            return !!getSerialById(elem.id);
        }
        else if (elem.type == "device") {
            return !!getDeviceById(elem.id);
        }
        else if (elem.type == measureTypeById(4).measurement_type) {
            return !!getDeviceById('C_' + elem.id);
        }
        else if (elem.type == "wall") {
            return !!getWallById(elem.id);
        }
        else {
            return true;
        } */
    return !!measureHelper.datum(elem);
  },
  /**
   *
   * @param {*} elem
   * @param {*} noOverride
   * @returns {Point}
   */
  getMeasurePtOf: function (elem, noOverride = false) {
    if (!noOverride && elem.measurePtOverride && elem.measurePtOverride.x
        && elem.measurePtOverride.y) {
      elem.center = elem.measurePtOverride;
      return elem.measurePtOverride;
    }
    if (elem.type == "serial") {
      return uDevDOM.getCenterOfSerial(elem.id);
    } else if (elem.type == "device") {
      return uDev.getCenterOfDevice_NoDOM(elem.id);
    } else if (elem.type == measureTypeById_T(MEASURE_TYPES.userCustomItem)) {
      return uDev.getCenterOfDevice_NoDOM('C_' + elem.id);
    } else {
      return elem.center;
    }
  },
  adjustMeasure: function (d) {
    var type = d.id ? "serial" : "device";
    var id = d.id ? d.id : d.devices[0].deviceId;
    var center = d.id ? getSerialCenterPos(d) : getDevicePositionCenter(
        getDeviceById(id));
    var toUpdate = [];
    for (var i = 0; i < PlannerGlobals.measurements.length; i++) {
      var src = PlannerGlobals.measurements[i].source;
      var tar = PlannerGlobals.measurements[i].target;
      if (src.type == type && src.id == id) {
        toUpdate.push(src);
      }
      if (tar.type == type && tar.id == id) {
        toUpdate.push(tar);
      }
    }
    for (var i = 0; i < toUpdate.length; i++) {
      toUpdate[i].center = P_numtoxy(center);
    }
  },
  startMeasure: function (d) {
    var source = originalFromD(d);
    if (d.devices.every(function (dev) {
      return dev.ghost;
    })) {
      return;
    }

    var center;
    this.sourceRoom = d.roomId;
    if (d.id) {
      center = getSerialCenterPos(d);
      this.sourceType = "serial";
      this.sourceId = d.id;
    } else if (d.connId) {
      const currXY = getXYP();
      const centersWithSerials = d.serials.map(
          ser => ({id: ser.serialId, center: getSerialCenterPos2(ser)}));
      centersWithSerials.sort(
          (a, b) => uMath.pointDistance(a.center, currXY) - uMath.pointDistance(
              b.center, currXY));
      this.sourceType = "serial";
      this.sourceId = centersWithSerials[0].id;
      center = P_xytonum(centersWithSerials[0].center);
    } else {
      center = getDevicePositionCenter(source);
      if (source.deviceId.toString().indexOf('C_') == 0) {
        this.sourceType = measureTypeById(4).measurement_type;
        this.sourceId = source.deviceId.toString().replace('C_', '');
      } else if (source.deviceId.toString().indexOf('S_') == 0) {
        this.sourceType = undefined;
        this.sourceId = undefined;
        this.sourceCenter = undefined;
        return;
      } else {
        this.sourceType = "device";
        this.sourceId = source.deviceId;
      }
    }
    this.sourceCenter = {x: center[0], y: center[1]};
    rebuildWallsCache(/* getRoomById(this.sourceRoom) */);
    setMode.measureMe();
  },
  startMeasureWall: function (xy, polyId) {
    return false; // disallowed now
    this.sourceType = "wall";
    this.sourceCenter = xy;
    setMode.measureMe();
  },
  startMeasureManual: function (xy) {
    if (this.sourceType) {
      return;
    }
    this.sourceType = "manual";
    this.sourceCenter = xy;
    setMode.measureMe();
  },
  resetMeasures: function () {
    this.sourceCenter = undefined;
    this.sourceId = undefined;
    this.sourceType = undefined;
    this.targetCenter = undefined;
    this.targetId = undefined;
    this.targetType = undefined;
  },
  validate: function () {
    return this.sourceType != "manual" &&
        (this.sourceCenter && this.targetCenter && uMath.pointDistance(
            this.sourceCenter, this.targetCenter) > 2);
  },
  alreadyConnected: function () {
    var st = this.sourceType;
    var si = this.sourceId;
    var tt = this.targetType;
    var ti = this.targetId;
    return !!PlannerGlobals.measurements.find(function (meas) {
      var src = meas.source;
      var tar = meas.target;
      return src.type == st && src.id == si &&
          tar.type == tt && tar.id == ti ||
          src.type == tt && src.id == ti &&
          tar.type == st && tar.id == si;
    });
  },
  endMeasure: function (e) {
    if (this.validate() && !this.alreadyConnected()) {
      /* if (this.targetType == "manual" && !MODKEYS_STATE.shift) {
                toastRemoveAll();
                toastInfo("You can only end a manual measurement while pressing Shift!");
            }
            else { */

      var measurement = {
        id: +new Date(),
        sentToServerPromise: $.Deferred(),
        source: {
          center: this.sourceCenter,
          type: this.sourceType,
          id: this.sourceId
        },
        target: {
          center: this.targetCenter,
          type: this.targetType,
          id: this.targetId
        },
        justAdded: true,
      }
      var isValid = isMeasurementValid(measurement, true, true);
      if (isValid) {
        PlannerGlobals.measurements.push(measurement);
        PlannerGlobals.measureSuccess = true;
        addMeasurementAjax(measurement, function () {
          var action = new CreateMeasurementAction(measurement);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
        });
      }
    }
    setMode.measurePrepare();
    //redrawMeasurements();
    this.resetMeasures();

  },
  getClosestDevToPoint: function (point) {
    if (this.deviceCentersCache.length == 0) {
      return false;
    }
    var minIdx = -1;
    var minVal = Number.MAX_VALUE;
    for (var i = 0; i < this.deviceCentersCache.length; i++) {
      var curr = this.deviceCentersCache[i];
      var dist = uMath.pointDistance(curr.center, point);
      if (dist < minVal) {
        minVal = dist;
        minIdx = i;
      }
    }
    var minDev = this.deviceCentersCache[minIdx];
    return {device: minDev.device, center: minDev.center, length: minVal};
  },
  getClosestSerialToPoint: function (point) {
    if (this.serialCentersCache.length == 0) {
      return false;
    }
    var minIdx = -1;
    var minVal = Number.MAX_VALUE;
    for (var i = 0; i < this.serialCentersCache.length; i++) {
      var curr = this.serialCentersCache[i];
      var dist = uMath.pointDistance(curr.center, point);
      if (dist < minVal) {
        minVal = dist;
        minIdx = i;
      }
    }
    var minSerial = this.serialCentersCache[minIdx];
    return {serial: minSerial.serial, center: minSerial.center, length: minVal};
  },
  getClosestWallModToPoint: function (point) {
    // filter walls/doors to get only ones that are perpendicular to the serial, are in the same room,
    // and the wall-serial distance is smaller than a given amount

    var roomWallMods = wallModHelper.getWallModsOfRoom(this.sourceRoom).filter(
        function (wallMod) {
          return !wallMod.isAJAXWait;
        });
    if (roomWallMods.length == 0) {
      return false;
    }
    // get closest of these to the cursor
    var minWallMod = null;
    var minSegment = null;
    var minVal = Number.MAX_VALUE;

    for (var i = 0; i < roomWallMods.length; i++) {
      var mod = roomWallMods[i];
      var segment = uMath.segmentFromPoints(mod.points[0], mod.points[1]);
      var cursorDist = distToWall(point, segment);
      if (cursorDist < minVal) {
        minVal = cursorDist;
        minSegment = segment;
        minWallMod = mod;
      }
    }

    // if the closest is closer than a given amount, snap to it
    return {
      center: uMath.segmentCenter(minSegment),
      id: minWallMod.id,
      length: minVal
    };
  },
  getTargetWallOrDev: function () {
    var xy = getXYP();

    if (measureHelper.sourceType != "manual") {
      // try snap to dev
      var closestDevToCursor = this.getClosestDevToPoint(xy);
      if (closestDevToCursor && closestDevToCursor.length
          < PlannerGlobals.DEVICE_SIZE /* * 1.5 */) {
        var id = closestDevToCursor.device.deviceId.toString()
        if (id.indexOf('C_') == 0) {
          this.targetType = measureTypeById(4).measurement_type;
          this.targetCenter = closestDevToCursor.center;
          this.targetId = +id.replace('C_', '');
        } else if (id.indexOf('S_') == 0) {
          this.targetType = undefined;
          this.targetCenter = undefined;
          this.targetId = undefined;
          return false;
        } else {
          this.targetType = "device";
          this.targetCenter = closestDevToCursor.center;
          this.targetId = +id;
        }
        return true;
      }

      // try snap to serial
      var closestSerialToCursor = this.getClosestSerialToPoint(xy);
      if (closestSerialToCursor && closestSerialToCursor.length
          < PlannerGlobals.DEVICE_SIZE * 1.5) {
        this.targetType = "serial";
        this.targetCenter = closestSerialToCursor.center;
        this.targetId = closestSerialToCursor.serial.id;
        return true;
      }

      // try snap to window/door
      /* if (this.sourceType == "serial") { */
      var closestWallModToPoint = this.getClosestWallModToPoint(xy);
      if (closestWallModToPoint && closestWallModToPoint.length < 2) {
        this.targetType = measureTypeById(5).measurement_type;
        this.targetCenter = closestWallModToPoint.center;
        this.targetId = closestWallModToPoint.id;
        return true;
      }
      /* } */

      // try snap to wall
      var closestWallToCursor = getClosestWallToPoint(xy);
      var cursorWallDist = uMath.pointDistance(xy,
          wallClosestPointToPoint(xy, closestWallToCursor));
      if (cursorWallDist < PlannerGlobals.DEVICE_SIZE) {
        // if perpendicular, source to wall
        var closestFromSourceToWall = wallClosestPointToPoint(this.sourceCenter,
            closestWallToCursor);
        if (uMath.pointDistance(closestFromSourceToWall, this.sourceCenter)
            > PlannerGlobals.DEVICE_SIZE * 2 / 3) {
          var v1 = uMath.vectorFromSegment(closestWallToCursor);
          var v2 = uMath.vectorFromSegment(
              uMath.segmentFromPoints(this.sourceCenter,
                  closestFromSourceToWall));
          var dotProduct = uMath.dotProduct(v1, v2);
          if (Math.abs(dotProduct) < 1) {

            this.targetCenter = closestFromSourceToWall;
            this.targetType = "wall";
            this.targetId = closestWallToCursor.id;
            return true;
          }
        }
      }
    }

    // manual
    this.targetType = undefined;
    this.targetCenter = undefined;
    this.targetId = undefined;
    return false;
  }
}